import React from "react";
import AssignOrder from "../../components/AssignOrder";
import { ORDER_TYPE } from "../../enums/order.enum";

const AssignLabOrder = () => {
  return <AssignOrder orderType={ORDER_TYPE.DIAGNOSTICS} />;
};

export default AssignLabOrder;
